import React, {useEffect} from 'react';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';
import HelpCenterSection from '../../PageComponent/ProfilePage/HelpCenterSection';

function MobileHelpcenter() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <div className="text-coalBlack pb-[20%] px-6 pt-10">
      <MobileProfileTopNavigation pageTitle={'Help Center'} />
      <HelpCenterSection />
    </div>
  );
}

export default MobileHelpcenter;
